import { Link } from '@inertiajs/react'
import PublicLayout from '@/layouts/PublicLayout'
import SeoHead from '@/components/SeoHead'

export default function DsarRequestThanksPage() {
  return (
    <>
      <SeoHead
        title="Request received — LendSolo"
        description="Your data subject access request has been received."
        canonicalPath="/privacy/dsar/thanks"
        ogType="article"
      />

      <PublicLayout
        title="Request received."
        description="We've received your data request and sent a confirmation to the email address you provided."
      >
        <div className="max-w-2xl space-y-6 text-gray-700 leading-relaxed">
          <p>
            Our team will review your request and respond within the timeframe required by
            the applicable privacy law. We may contact you by email to verify your identity
            before processing.
          </p>

          <p className="text-sm text-gray-500">
            If you don't see our confirmation email within a few minutes, check your spam folder.
          </p>

          <div className="pt-2">
            <Link
              href="/"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg text-sm font-semibold text-white bg-emerald-600 hover:bg-emerald-700 transition-colors"
            >
              Return to lendsolo.com
            </Link>
          </div>
        </div>
      </PublicLayout>
    </>
  )
}
